import React from 'react'

export default function PageNotFound() {
    return (
        <h1>The page you are looking for is not found!!</h1>
    )
}
